// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fe-select-none[data-v-8d2b8d48]{-webkit-user-select:none;-o-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.content-6__chartbox__number[data-v-8d2b8d48]{padding:.19324rem 0 0}", ""]);
// Exports
module.exports = exports;
